<template>
  <div class="flex flex-col rounded-lg p-4 shadow-md bg-white justify-center items-center
      border-2 border-gray-400 transition transition duration-500 ease-in-out hover:border-gray-600">
    <h4 class="text-lg font-semibold">{{ admissionContact.name }}</h4>
    <p class="text-gray-500 font-medium mb-0 mt-1">{{ admissionContact.departments }}</p>
    <p class="text-gray-500 font-normal">{{ admissionContact.designation }}</p>
    <div class="flex justify-between items-center gap-x-2 mt-1"><i class="pi pi-mobile"></i> <span
        class="text-gray-500 font-medium">{{ admissionContact.mobile }}</span></div>
    <div class="flex justify-between items-center gap-x-2"><i class="pi pi-envelope"></i> <span
        class="text-gray-500 font-medium">{{ admissionContact.email }}</span></div>
  </div>
</template>

<script>
export default {
  name: "AdmissionContactCard",
  props: {
    admissionContact: Object
  }
}
</script>

<style scoped>

</style>
